(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('expressApiConfig', {
            parent: 'module',
            url: '/expressApiConfig',
            data: {
                authorities: ['ROLE_EXPRESS_API']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/expressApiConfig/expressApiConfig.html',
                    controller: 'ExpressApiConfigController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
    }
})();
